// 导入配置
import config from '../config';

// 添加请求计数器用于调试
let requestCounter = 0;
const activeRequests = {};

// 获取API基础URL
const API_BASE_URL = config.api.getBaseUrl();

// 如果需要手动指定API服务器地址，可以取消下面注释并设置具体的URL
// const API_BASE_URL = 'http://your-api-server-url';

// 检查一个字符串是否可能是大整数
const isBigIntString = (str) => {
  // 检查是否是纯数字字符串
  if (!/^\d+$/.test(str)) return false;
  
  // 检查长度是否超过JavaScript安全整数范围
  // Number.MAX_SAFE_INTEGER 是 9007199254740991 (16位)
  return str.length >= 16;
};

// 自定义JSON解析器，处理大整数
const parseJsonWithBigInt = (jsonText) => {
  // 预处理JSON文本，将大整数转换为字符串
  // 正则表达式匹配JSON中的大整数（超过16位的数字）
  const processedText = jsonText.replace(/"(nextCursor|cursor|messageId)":\s*(\d{16,})/g, '"$1":"$2"');
  
  try {
    return JSON.parse(processedText);
  } catch (error) {
    console.error('JSON解析错误，尝试使用原始文本:', error);
    return JSON.parse(jsonText);
  }
};

const api = {
    fetchWithToken: async (url, options = {}) => {
        // 记录请求ID和URL
        const requestId = ++requestCounter;
        const startTime = Date.now();
        const fullUrl = `${API_BASE_URL}${url}`;
        activeRequests[requestId] = { url: fullUrl, startTime };
        
        // API请求开始
        
        const token = localStorage.getItem('satoken');

        const headers = {
            ...options.headers
        };

        // ✅ 只有在不是 FormData 的情况下才手动加 Content-Type
        const isFormData = options.body instanceof FormData;
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }

        // ✅ 正确加上 token
        if (token) {
            headers['satoken'] = token;
        }

        const newOptions = {
            ...options,
            headers
        };

        try {
            const response = await fetch(fullUrl, newOptions);
            const responseText = await response.text();
            
            // 使用自定义解析器处理JSON，正确处理大整数
            const data = parseJsonWithBigInt(responseText);
            
            // 计算请求耗时
            const endTime = Date.now();
            const duration = endTime - startTime;
            
            // API请求完成
            
            // 清理请求记录
            delete activeRequests[requestId];
            
            return data;
        } catch (error) {
            // API请求错误
            console.error(`API请求错误 [${fullUrl}]:`, error);
            
            // 清理请求记录
            delete activeRequests[requestId];
            
            throw error;
        }
    },
    
    // 获取当前活跃请求的统计信息
    getActiveRequestsStats: () => {
        const activeCount = Object.keys(activeRequests).length;
        const urls = Object.values(activeRequests).map(req => req.url);
        
        return {
            activeCount,
            urls,
            totalRequests: requestCounter
        };
    },

    // 查询公开的拾光纪条目
    queryPublicTimeNestList: async (pageNum, pageSize) => {
        return api.fetchWithToken('/timeNest/queryPublicTimeNestList', {
            method: 'POST',
            body: JSON.stringify({
                pageNum,
                pageSize
            })
        });
    },
    
    // 微信服务器验证接口 (GET请求)
    wxCallbackVerify: async (signature, timestamp, nonce, echostr) => {
        const queryParams = new URLSearchParams({
            signature,
            timestamp,
            nonce,
            echostr
        }).toString();
        
        return api.fetchWithToken(`/wx/callback?${queryParams}`, {
            method: 'GET'
        });
    },
    
    // 接收微信消息接口 (POST请求)
    wxCallbackMessage: async (requestBody, signature, timestamp, nonce, msgSignature = '') => {
        const queryParams = new URLSearchParams({
            signature,
            timestamp,
            nonce
        });
        
        // 如果提供了msg_signature，则添加到查询参数中
        if (msgSignature) {
            queryParams.append('msg_signature', msgSignature);
        }
        
        return api.fetchWithToken(`/wx/callback?${queryParams.toString()}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml;charset=UTF-8'
            },
            body: requestBody // 直接传递XML格式的请求体
        });
    }
};

export default api;